import 'svelte/internal/disclose-version';
import * as $ from 'svelte/internal/client';
import { copy, selectTransferPresentation } from "@aasaan-share/ui-contract";
import { photoTransferActionMode } from "../transfer-actions.ts";
import Icon from "./Icon.svelte";

var root = $.from_html(`<img/>`);
var root_1 = $.from_html(`<div class="dialog-loading" role="status">Loading preview...</div>`);
var root_2 = $.from_html(`<button aria-label="Previous photo" class="photo-navigation photo-navigation-previous" data-action="previous-photo" title="Previous photo" type="button"><!></button>`);
var root_3 = $.from_html(`<button aria-label="Next photo" class="photo-navigation photo-navigation-next" data-action="next-photo" title="Next photo" type="button"><!></button>`);
var root_4 = $.from_html(`<button class="secondary-button photo-download-button" data-action="cancel-download" type="button"> </button>`);
var root_5 = $.from_html(`<button class="primary-button photo-download-button" data-action="download-photo" type="button"><!> </button>`);
var root_6 = $.from_html(`<div class="photo-download-control"><p data-photo-download-copy=""> </p> <div aria-valuemax="100" aria-valuemin="0" class="progress-track photo-download-progress" data-photo-download-progress="" role="progressbar"><span data-photo-download-progress-bar=""></span></div> <div data-photo-download-actions=""><!></div></div>`);
var root_7 = $.from_html(`<dialog aria-describedby="photo-position" aria-labelledby="photo-dialog-title" class="media-dialog photo-dialog" data-dialog="photo"><div class="photo-shell"><header class="photo-header"><button class="icon-button photo-close-button" data-action="close-dialog" type="button"><!></button> <h2 class="photo-title" id="photo-dialog-title"> </h2> <button aria-label="Zoom photo" class="icon-button photo-zoom-button" title="Zoom photo" type="button"><!></button></header> <div data-photo-swipe=""><!> <!> <!></div> <footer class="photo-footer"><!> <span class="photo-position" id="photo-position"> </span></footer></div></dialog>`);

export default function PhotoDialog($$anchor, $$props) {
	$.push($$props, true);

	let stage;
	let pointers = new Map();
	let pinchStartDistance = 0;
	let pinchStartScale = 1;
	let scale = $.state(1);
	let swipeStart;
	let zoomedMediaId = "";

	let presentation = $.derived(() => $$props.transferState
		? selectTransferPresentation($$props.transferState)
		: undefined);

	let progressPercent = $.derived(() => Math.round(($$props.progress ?? 0) * 100));
	let actionMode = $.derived(() => photoTransferActionMode($$props.transferState));
	let active = $.derived(() => $.get(actionMode) === "active");
	let activePhotoIndex = $.derived(() => Math.max(0, $$props.photos.findIndex((photo) => photo.id === $$props.media.id)));

	$.user_effect(() => {
		if (zoomedMediaId === $$props.media.id) return;

		zoomedMediaId = $$props.media.id;
		resetZoom();
	});

	function resetZoom() {
		pointers.clear();
		pinchStartDistance = 0;
		pinchStartScale = 1;
		$.set(scale, 1);
		swipeStart = undefined;
	}

	function togglePhotoZoom() {
		$.set(scale, $.get(scale) > 1 ? 1 : 2, true);
	}

	function handlePointerDown(event) {
		if (event.isPrimary) {
			pointers.clear();

			swipeStart = $.get(scale) === 1
				? {
					pointerId: event.pointerId,
					x: event.clientX,
					y: event.clientY
				}
				: undefined;
		}

		pointers.set(event.pointerId, { x: event.clientX, y: event.clientY });

		if (pointers.size === 2) {
			pinchStartDistance = pointerDistance();
			pinchStartScale = $.get(scale);
		}
	}

	function handlePointerMove(event) {
		if (!pointers.has(event.pointerId)) return;

		pointers.set(event.pointerId, { x: event.clientX, y: event.clientY });

		if (pointers.size < 2) {
			if ($.get(scale) > 1) event.preventDefault();

			return;
		}

		const distance = pointerDistance();

		if (pinchStartDistance === 0) return;

		$.set(scale, Math.min(4, Math.max(1, pinchStartScale * distance / pinchStartDistance)), true);
		event.preventDefault();
	}

	function handlePointerUp(event) {
		const wasZoomed = $.get(scale) > 1;
		const wasPinching = pointers.size > 1;

		pointers.delete(event.pointerId);

		if (!wasPinching) pointers.clear();

		if (wasZoomed || wasPinching || swipeStart?.pointerId !== event.pointerId) {
			return;
		}

		const horizontalDistance = event.clientX - swipeStart.x;
		const verticalDistance = event.clientY - swipeStart.y;

		swipeStart = undefined;

		if (Math.abs(horizontalDistance) < 48 || Math.abs(horizontalDistance) <= Math.abs(verticalDistance)) {
			return;
		}

		const next = $$props.photos[$.get(activePhotoIndex) + (horizontalDistance < 0 ? 1 : -1)];

		if (!next) return;

		stage.dispatchEvent(new CustomEvent("aasaan:photo-position", { bubbles: true, detail: { mediaId: next.id } }));
	}

	function handleWheelZoom(event) {
		if (event.deltaY === 0) return;

		event.preventDefault();

		const factor = event.deltaY < 0 ? 1.15 : 1 / 1.15;

		$.set(scale, Math.min(4, Math.max(1, $.get(scale) * factor)), true);
	}

	function pointerDistance() {
		const [first, second] = [...pointers.values()];

		return first && second
			? Math.hypot(second.x - first.x, second.y - first.y)
			: 0;
	}

	var dialog = root_7();
	var div = $.child(dialog);
	var header = $.child(div);
	var button = $.child(header);
	var node = $.child(button);

	Icon(node, { name: 'close' });
	$.reset(button);

	var h2 = $.sibling(button, 2);
	var text = $.child(h2, true);

	$.reset(h2);

	var button_1 = $.sibling(h2, 2);
	var node_1 = $.child(button_1);

	Icon(node_1, { name: 'zoomIn' });
	$.reset(button_1);
	$.reset(header);

	var div_1 = $.sibling(header, 2);
	let classes;
	var node_2 = $.child(div_1);

	{
		var consequent = ($$anchor) => {
			var img = root();

			$.template_effect(() => {
				$.set_attribute(img, 'alt', $$props.media.label);
				$.set_attribute(img, 'src', $$props.media.source);
				$.set_style(img, `transform: scale(${$.get(scale)});`);
			});

			$.append($$anchor, img);
		};

		var alternate = ($$anchor) => {
			var div_2 = root_1();

			$.append($$anchor, div_2);
		};

		$.if(node_2, ($$render) => {
			if ($$props.media.source) $$render(consequent); else $$render(alternate, -1);
		});
	}

	var node_3 = $.sibling(node_2, 2);

	{
		var consequent_1 = ($$anchor) => {
			var button_2 = root_2();
			var node_4 = $.child(button_2);

			Icon(node_4, { name: 'previous' });
			$.reset(button_2);
			$.append($$anchor, button_2);
		};

		$.if(node_3, ($$render) => {
			if ($.get(activePhotoIndex) > 0) $$render(consequent_1);
		});
	}

	var node_5 = $.sibling(node_3, 2);

	{
		var consequent_2 = ($$anchor) => {
			var button_3 = root_3();
			var node_6 = $.child(button_3);

			Icon(node_6, { name: 'next' });
			$.reset(button_3);
			$.append($$anchor, button_3);
		};

		$.if(node_5, ($$render) => {
			if ($.get(activePhotoIndex) < $$props.photos.length - 1) $$render(consequent_2);
		});
	}

	$.reset(div_1);
	$.bind_this(div_1, ($$value) => stage = $$value, () => stage);

	var footer = $.sibling(div_1, 2);
	var node_7 = $.child(footer);

	{
		var consequent_5 = ($$anchor) => {
			var div_3 = root_6();
			var p = $.child(div_3);
			var text_1 = $.child(p, true);

			$.reset(p);

			var div_4 = $.sibling(p, 2);
			var span = $.child(div_4);

			$.reset(div_4);

			var div_5 = $.sibling(div_4, 2);
			var node_8 = $.child(div_5);

			{
				var consequent_3 = ($$anchor) => {
					var button_4 = root_4();
					var text_2 = $.child(button_4, true);

					$.reset(button_4);
					$.template_effect(() => $.set_text(text_2, copy["action.cancel"]));
					$.append($$anchor, button_4);
				};

				var consequent_4 = ($$anchor) => {
					var button_5 = root_5();
					var node_9 = $.child(button_5);

					Icon(node_9, { name: 'retry' });

					var text_3 = $.sibling(node_9);

					$.reset(button_5);

					$.template_effect(() => {
						$.set_attribute(button_5, 'data-media-id', $$props.media.id);
						$.set_text(text_3, ` ${copy["action.tryAgain"] ?? ''}`);
					});

					$.append($$anchor, button_5);
				};

				var alternate_1 = ($$anchor) => {
					var button_6 = root_5();
					var node_10 = $.child(button_6);

					Icon(node_10, { name: 'download' });

					var text_4 = $.sibling(node_10);

					$.reset(button_6);

					$.template_effect(() => {
						$.set_attribute(button_6, 'data-media-id', $$props.media.id);
						$.set_text(text_4, ` ${copy["action.downloadOriginal"] ?? ''}`);
					});

					$.append($$anchor, button_6);
				};

				$.if(node_8, ($$render) => {
					if ($.get(actionMode) === "active") $$render(consequent_3); else if ($.get(actionMode) === "failed") $$render(consequent_4, 1); else $$render(alternate_1, -1);
				});
			}

			$.reset(div_5);
			$.reset(div_3);

			$.template_effect(
				($0) => {
					$.set_attribute(p, 'aria-live', $.get(presentation)?.announce ? "polite" : undefined);

					$.set_class(p, 1, $.clsx($$props.transferState
						? `photo-download-copy transfer-${$$props.transferState}`
						: "photo-download-copy"));

					$.set_attribute(p, 'hidden', !$.get(presentation)?.copyKey);
					$.set_attribute(p, 'role', $.get(presentation)?.announce ? "status" : undefined);

					$.set_text(text_1, $.get(presentation)?.copyKey
						? `${copy[$.get(presentation).copyKey]}${$.get(active) ? ` ${$.get(progressPercent)}%` : ""}`
						: "");

					$.set_attribute(div_4, 'aria-label', `Original download ${$.get(progressPercent)}%`);
					$.set_attribute(div_4, 'aria-valuenow', $0);
					$.set_attribute(div_4, 'hidden', !$.get(active));
					$.set_style(span, `width:${$.get(progressPercent)}%`);
				},
				[() => String($.get(progressPercent))]
			);

			$.append($$anchor, div_3);
		};

		$.if(node_7, ($$render) => {
			if ($$props.access === "download") $$render(consequent_5);
		});
	}

	var span_1 = $.sibling(node_7, 2);
	var text_5 = $.child(span_1);

	$.reset(span_1);
	$.reset(footer);
	$.reset(div);
	$.reset(dialog);

	$.template_effect(() => {
		$.set_attribute(dialog, 'data-media-id', $$props.media.id);
		$.set_attribute(button, 'aria-label', copy["action.close"]);
		$.set_attribute(button, 'title', copy["action.close"]);
		$.set_text(text, $$props.media.label);
		classes = $.set_class(div_1, 1, 'photo-stage', null, classes, { 'is-zoomed': $.get(scale) > 1 });
		$.set_attribute(span_1, 'aria-label', `Photo ${$.get(activePhotoIndex) + 1} of ${$$props.photos.length}`);
		$.set_text(text_5, `${$.get(activePhotoIndex) + 1} / ${$$props.photos.length ?? ''}`);
	});

	$.delegated('click', button_1, togglePhotoZoom);
	$.delegated('dblclick', div_1, togglePhotoZoom);
	$.event('pointercancel', div_1, resetZoom);
	$.delegated('pointerdown', div_1, handlePointerDown);
	$.delegated('pointermove', div_1, handlePointerMove);
	$.delegated('pointerup', div_1, handlePointerUp);
	$.event('wheel', div_1, handleWheelZoom);
	$.append($$anchor, dialog);
	$.pop();
}

$.delegate([
	'click',
	'dblclick',
	'pointerdown',
	'pointermove',
	'pointerup'
]);